import {
  Flex,
  UnorderedList as List,
  ListItem,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';
import CloseIcon from '@components/icons/CloseIcon';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';

const DrugNotCoveredModal = ({ isOpen, handleClose, prescriptions }) => {
  if (!prescriptions) return null;

  const notCovered = prescriptions.filter((pscrip) => pscrip.inNetworkPercentage === 0);

  const renderDrugs = () =>
    notCovered.map((drug) => (
      <ListItem key={drug.value} ml={4}>
        <Body1>{drug.name}</Body1>
      </ListItem>
    ));

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent
        borderRadius={0}
        background="white"
        border={antlerStyle.border}
        borderColor="red.400 !important"
        id="exit_intent_modal"
        maxWidth="600px"
        paddingY={4}
      >
        <ModalHeader>
          <Flex justifyContent="space-between">
            <Header as="h1">Important 🚨</Header>
            <CloseIcon onClick={handleClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Stack spacing={6}>
            <Body1>The following prescriptions aren't covered by Medicare:</Body1>
            <List spacing={2}>{renderDrugs()}</List>
            <Body1>Since no plans cover this prescription, we'll exclude it and run our algorithm again.</Body1>
          </Stack>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button width="100%" onClick={handleClose}>
            Continue
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DrugNotCoveredModal;
